import { render, staticRenderFns } from "./Assessment1.vue?vue&type=template&id=51d8d824&scoped=true"
import script from "./Assessment1.vue?vue&type=script&lang=js"
export * from "./Assessment1.vue?vue&type=script&lang=js"
import style0 from "./Assessment1.vue?vue&type=style&index=0&id=51d8d824&prod&lang=scss"
import style1 from "./Assessment1.vue?vue&type=style&index=1&id=51d8d824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8d824",
  null
  
)

export default component.exports